<template>
  <label class="glass-checkbox" :class="{ 'is-disabled': disabled, 'is-checked': isChecked }">
    <input
      type="checkbox"
      :checked="isChecked"
      :disabled="disabled"
      :name="name"
      :value="value"
      @change="handleChange"
      class="checkbox-input"
    />
    <span class="checkbox-box">
      <svg v-if="isChecked" class="checkbox-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <polyline points="20 6 9 17 4 12" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
    <span class="checkbox-label">
      <slot></slot>
    </span>
  </label>
</template>

<script>
export default {
  name: 'GlassCheckbox',
  emits: ['update:modelValue', 'change'],
  props: {
    modelValue: {
      type: [Boolean, Array],
      default: false
    },
    value: {
      type: [String, Number, Boolean, Object],
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    }
  },
  computed: {
    isChecked() {
      if (Array.isArray(this.modelValue)) {
        return this.modelValue.includes(this.value);
      }
      return this.modelValue === true || this.modelValue === this.value;
    }
  },
  methods: {
    handleChange(event) {
      if (this.disabled) return;
      
      if (Array.isArray(this.modelValue)) {
        const newValue = [...this.modelValue];
        if (event.target.checked) {
          newValue.push(this.value);
        } else {
          const index = newValue.indexOf(this.value);
          if (index > -1) newValue.splice(index, 1);
        }
        this.$emit('update:modelValue', newValue);
      } else {
        this.$emit('update:modelValue', event.target.checked);
      }
      this.$emit('change', event.target.checked);
    }
  }
};
</script>

<style scoped>
.glass-checkbox {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  user-select: none;
}

.glass-checkbox.is-disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.checkbox-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.checkbox-box {
  width: 1.25rem;
  height: 1.25rem;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.glass-checkbox:hover:not(.is-disabled) .checkbox-box {
  border-color: var(--theme-primary);
  background: rgba(59, 136, 165, 0.1);
}

.glass-checkbox.is-checked .checkbox-box {
  background: var(--theme-primary);
  border-color: var(--theme-primary);
}

.checkbox-icon {
  width: 14px;
  height: 14px;
  color: white;
}

.checkbox-label {
  font-size: 0.9375rem;
  color: var(--color-text);
  line-height: 1.4;
}

/* Dark variant */
.glass-checkbox.dark .checkbox-box {
  border-color: rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.05);
}

.glass-checkbox.dark:hover:not(.is-disabled) .checkbox-box {
  background: rgba(59, 136, 165, 0.15);
}
</style>
